module.exports = __webpack_public_path__ + "img/vivasigns.8374de0e.png";